export default __webpack_public_path__ + "images/B6.42780d1.png";